/**
 * AYP年上年下恋爱倾向测试 - 星座数据
 * 
 * 包含12星座的性格特质和恋爱关系特点
 */

export const ZODIAC_DATA = {
  aries: {
    name: "白羊座",
    icon: "♈",
    traits: ["热情", "直接", "冲动", "勇敢"],
    relationship: "白羊座在恋爱中通常直接而热情,喜欢主动追求,在年上年下关系中倾向于展现领导力和保护欲。白羊座的年上倾向者会欣赏伴侣的成熟稳重,而年下倾向者则享受引导和激励伴侣的过程。",
    advice: [
      "学习在冲动和理性之间找到平衡",
      "给予伴侣足够的个人空间",
      "培养耐心,倾听伴侣的需求",
      "在关系中保持热情的同时也要注重稳定性"
    ]
  },
  taurus: {
    name: "金牛座",
    icon: "♉",
    traits: ["稳定", "忠诚", "固执", "务实"],
    relationship: "金牛座重视稳定和忠诚,在恋爱关系中追求长期承诺。金牛座的年上倾向者会被成熟可靠的伴侣吸引,而年下倾向者则愿意为伴侣提供坚实的物质和情感支持。",
    advice: [
      "学习适应变化,保持关系的新鲜感",
      "在固执和妥协之间找到平衡",
      "表达情感时更加主动和直接",
      "重视精神层面的连接,不只是物质安全"
    ]
  },
  gemini: {
    name: "双子座",
    icon: "♊",
    traits: ["好奇", "善变", "沟通", "自由"],
    relationship: "双子座需要自由和变化,在恋爱中重视精神交流。双子座的年上倾向者会被智慧和经验丰富的伴侣吸引,而年下倾向者则享受与伴侣分享新知识和新体验。",
    advice: [
      "学习在关系中保持专注和承诺",
      "平衡自由需求和伴侣的安全感需求",
      "深化情感连接,不只停留在表面交流",
      "培养稳定性,给予伴侣可靠感"
    ]
  },
  cancer: {
    name: "巨蟹座",
    icon: "♋",
    traits: ["情感丰富", "保护性强", "敏感", "家庭导向"],
    relationship: "巨蟹座情感丰富,保护欲强,在恋爱中重视家庭和情感安全。巨蟹座的年上倾向者渴望被照顾和保护,而年下倾向者则愿意为伴侣营造温暖的家庭氛围。",
    advice: [
      "学习表达需求,不要期待伴侣总能读懂你的心",
      "在保护和给予自由之间找到平衡",
      "培养独立性,避免过度依赖情感连接",
      "学习处理情绪波动,保持关系稳定"
    ]
  },
  leo: {
    name: "狮子座",
    icon: "♌",
    traits: ["自信", "热情", "领导力", "慷慨"],
    relationship: "狮子座自信热情,在恋爱中希望成为伴侣生活的中心。狮子座的年上倾向者会欣赏能够引导自己的强大伴侣,而年下倾向者则享受照耀和提升伴侣的感觉。",
    advice: [
      "学习倾听和尊重伴侣的意见",
      "在自信和谦逊之间找到平衡",
      "给予伴侣足够的关注和认可",
      "避免过度控制,尊重伴侣的独立性"
    ]
  },
  virgo: {
    name: "处女座",
    icon: "♍",
    traits: ["细致", "分析力强", "挑剔", "务实"],
    relationship: "处女座注重细节和完美,在恋爱中追求实际和稳定。处女座的年上倾向者会被成熟理性的伴侣吸引,而年下倾向者则愿意帮助伴侣改善和成长。",
    advice: [
      "学习接受不完美,降低对伴侣的期待",
      "在批评和鼓励之间找到平衡",
      "表达情感时更加温暖和直接",
      "培养包容心,欣赏伴侣的独特之处"
    ]
  },
  libra: {
    name: "天秤座",
    icon: "♎",
    traits: ["平衡", "社交", "优雅", "和谐"],
    relationship: "天秤座追求平衡和谐,在恋爱中重视公平和美感。天秤座的年上年下倾向通常较为平衡,能够适应不同类型的关系模式,重视精神层面的契合。",
    advice: [
      "学习做出决定,不要过度犹豫",
      "在取悦他人和满足自己之间找到平衡",
      "表达真实想法,不要为了和谐而压抑自己",
      "培养独立性,避免过度依赖伴侣的认可"
    ]
  },
  scorpio: {
    name: "天蝎座",
    icon: "♏",
    traits: ["强烈", "神秘", "忠诚", "深刻"],
    relationship: "天蝎座情感强烈,忠诚度高,在恋爱中追求深度连接。天蝎座的年上倾向者会被神秘强大的伴侣吸引,而年下倾向者则愿意深度探索和引导伴侣的内心世界。",
    advice: [
      "学习信任,不要过度控制伴侣",
      "在深度连接和给予空间之间找到平衡",
      "表达情感时更加开放和脆弱",
      "培养宽容心,接受关系中的不完美"
    ]
  },
  sagittarius: {
    name: "射手座",
    icon: "♐",
    traits: ["自由", "乐观", "冒险", "独立"],
    relationship: "射手座热爱自由,在恋爱中追求探索和成长。射手座的年上倾向者会被智慧和经验丰富的伴侣吸引,而年下倾向者则愿意带领伴侣探索世界和人生。",
    advice: [
      "学习承诺,不要逃避关系中的责任",
      "在自由和亲密之间找到平衡",
      "深化情感连接,不只停留在表面的快乐",
      "培养稳定性,给予伴侣安全感"
    ]
  },
  capricorn: {
    name: "摩羯座",
    icon: "♑",
    traits: ["务实", "责任感强", "目标导向", "可靠"],
    relationship: "摩羯座务实且有责任感,在恋爱中重视长期规划和稳定性。摩羯座的年上倾向者会被成熟可靠的伴侣吸引,而年下倾向者则愿意为伴侣提供坚实的支持和指导。",
    advice: [
      "学习表达情感,不要过于理性和克制",
      "在工作和关系之间找到平衡",
      "培养浪漫和趣味,不要让关系过于严肃",
      "学习放松和享受当下,不只关注未来"
    ]
  },
  aquarius: {
    name: "水瓶座",
    icon: "♒",
    traits: ["独立", "创新", "理性", "友善"],
    relationship: "水瓶座重视独立和个人空间,在恋爱中追求精神连接和思想共鸣。水瓶座的年上年下倾向通常较为独特,更关注伴侣的思想深度而非年龄。",
    advice: [
      "学习表达情感,不要过于理性和疏离",
      "在独立和亲密之间找到平衡",
      "深化情感连接,不只停留在思想层面",
      "培养温暖,给予伴侣足够的情感支持"
    ]
  },
  pisces: {
    name: "双鱼座",
    icon: "♓",
    traits: ["敏感", "浪漫", "同情心强", "理想化"],
    relationship: "双鱼座浪漫敏感,在恋爱中追求深度的情感连接和精神共鸣。双鱼座的年上倾向者渴望被理解和保护,而年下倾向者则愿意为伴侣提供无条件的爱和支持。",
    advice: [
      "学习设立界限,不要过度牺牲自己",
      "在理想和现实之间找到平衡",
      "培养独立性,避免过度依赖伴侣",
      "学习面对现实,不要逃避关系中的问题"
    ]
  }
};

// 星座选项列表
export const ZODIAC_OPTIONS = [
  { value: "aries", label: "白羊座", icon: "♈", dateRange: "3/21-4/19" },
  { value: "taurus", label: "金牛座", icon: "♉", dateRange: "4/20-5/20" },
  { value: "gemini", label: "双子座", icon: "♊", dateRange: "5/21-6/21" },
  { value: "cancer", label: "巨蟹座", icon: "♋", dateRange: "6/22-7/22" },
  { value: "leo", label: "狮子座", icon: "♌", dateRange: "7/23-8/22" },
  { value: "virgo", label: "处女座", icon: "♍", dateRange: "8/23-9/22" },
  { value: "libra", label: "天秤座", icon: "♎", dateRange: "9/23-10/23" },
  { value: "scorpio", label: "天蝎座", icon: "♏", dateRange: "10/24-11/22" },
  { value: "sagittarius", label: "射手座", icon: "♐", dateRange: "11/23-12/21" },
  { value: "capricorn", label: "摩羯座", icon: "♑", dateRange: "12/22-1/19" },
  { value: "aquarius", label: "水瓶座", icon: "♒", dateRange: "1/20-2/18" },
  { value: "pisces", label: "双鱼座", icon: "♓", dateRange: "2/19-3/20" }
];

/**
 * 根据星座key获取星座数据
 * @param {string} zodiacKey - 星座key
 * @returns {Object} 星座数据
 */
export function getZodiacData(zodiacKey) {
  return ZODIAC_DATA[zodiacKey] || null;
}

/**
 * 根据星座key获取星座名称
 * @param {string} zodiacKey - 星座key
 * @returns {string} 星座名称
 */
export function getZodiacName(zodiacKey) {
  const zodiac = ZODIAC_DATA[zodiacKey];
  return zodiac ? zodiac.name : '未知星座';
}

/**
 * 根据星座key获取星座图标
 * @param {string} zodiacKey - 星座key
 * @returns {string} 星座图标
 */
export function getZodiacIcon(zodiacKey) {
  const zodiac = ZODIAC_DATA[zodiacKey];
  return zodiac ? zodiac.icon : '⭐';
}

